import { createSelector } from '@reduxjs/toolkit';

import { sortAnalysisHistoryDescending } from '@paragon/client-tools';

import { RootState } from '..';
import { getActiveComponentDesign } from './getActiveComponentDesignSelector';

const getAnalysisHistory = (state: RootState) => state.analysisHistory;
const getActiveComponentDesignGuid = createSelector(getActiveComponentDesign, (design) => design?.guid);

export function createGetAnalysisHistoryForComponentDesign(componentDesignGuid: string | undefined) {
  return createSelector(getAnalysisHistory, (analysisHistory) => {
    if (componentDesignGuid == null || !analysisHistory[componentDesignGuid]) return null;

    return sortAnalysisHistoryDescending(Object.values(analysisHistory[componentDesignGuid]));
  });
}

const createGetAnalysisHistoryForActiveComponentDesign = createSelector(
  getActiveComponentDesignGuid,
  createGetAnalysisHistoryForComponentDesign,
);

export function getAnalysisHistoryForActiveComponentDesign(state: RootState) {
  return createGetAnalysisHistoryForActiveComponentDesign(state)(state);
}
